import { AnalyticsConnector } from '@amplitude/analytics-connector';
export var getAnalyticsConnector = function () {
    return AnalyticsConnector.getInstance('$default_instance');
};
//# sourceMappingURL=analytics-connector.js.map